import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice
const name = "profile";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const profileAction = { ...slice.actions, ...extraActions };
export const profileReducer = slice.reducer;

// implementation
function createInitialState() {
  return {
    getProfileResponse: {},
    UpdateProfileResponse: {},
    loading: false,
  };
}

function createReducers() {
  return {
    clearOTPResponse,
    clearProfileResponse,
  };

  function clearProfileResponse(state) {
    state.getProfileResponse = {};
  }

  function clearOTPResponse(state) {
    state.signUpResponse = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}`;

  return {
    getMyProfile: getMyProfile(),
    updateMyProfile: updateMyProfile(),
  };

  function getMyProfile() {
    return createAsyncThunk(`${name}/getProfile`, async (id) => {
      return await fetchWrapper.get(`${baseUrl}/users/updateProfile`);
      // return await fetchWrapper.get(`${baseUrl}/users/updateProfile/${id}`);
    });
  }

  function updateMyProfile() {
    return createAsyncThunk(`${name}/updateProfile`, async (data) => {
      return await fetchWrapper.post(`${baseUrl}/users/updateProfile`, data);
    });
  }
}

function createExtraReducers(builder) {
  builder

    // Get Profile
    .addCase(extraActions.getMyProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.getMyProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.getProfileResponse = action?.payload?.data?.user;
      state.error = null;
    })
    .addCase(extraActions.getMyProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to register";
    })

    // Update Profile
    .addCase(extraActions.updateMyProfile.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.updateMyProfile.fulfilled, (state, action) => {
      state.loading = false;
      state.UpdateProfileResponse = action?.payload;
      sessionStorage.setItem(
        "loggedUserName",
        action?.payload?.data?.user?.firstName +
          " " +
          action?.payload?.data?.user?.lastName
      );
      sessionStorage.setItem(
        "committee_Id",
        JSON.stringify(action?.payload?.data?.user?.committees)
      );
      state.error = null;
    })
    .addCase(extraActions.updateMyProfile.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Failed to get committees";
    });
}
